export default {
  language: '中文',
  menu: {
    slab: '大板',
    spot: '现货仓',
    share: '共享仓',
    local: '本地仓',
    benefits: '会员福利',
    user: '用户',
    home: '首页'
  },
  search: '搜索',
  searchPlaceholder: '搜索关键字',
  searchPlaceholderThickness: '请输入厚度，如 30 或 30mm',
  back: '返回',
  next: '下一页',
  previous: '上一页',
  width: '宽度',
  length: '长度',
  weight: '重量',
  noData: '暂无数据',
  thickness: '厚度',
  processing_surface: '加工面',
  // 新增以下字段
  loading: '加载中',
  allLoaded: '已全部加载',
  loadMore: '加载更多',
  notFound: '未找到数据',
  stoneType: '品种',
  stoneNo: '批号',
  shelfCount: '批数',
  totalPiece: '总片数',
  basicInfo: '库存信息',
  sumArea: '总面积',
  filterTitle: '筛选条件',
  bookMatch: '对纹',
  yes: '是',
  no: '否',
  material: '品名',
  lot: '批号',
  total_quantity: '总数量',
  noDataFound: "未找到相关数据",
  thick: '厚度',
  booked: '已预订',
  piece_no: '片号', // Added typ
  book_match: '对纹',
  surface: '加工面',
  pieces: '片', // Added typ
  imageLoading: '图片加载中',
  searchPlaceholderBlock: '搜索批号',
  imageLoadError: '无图片',
  warehouse: '\u4ed3\u5e93',
  bundle_no: '\u67B6\u53F7',
  price_note: '\u4ef7\u683c\u8bf4\u660e',
  all_warehouse: '全部仓库',
}
